import { c as _c } from "react/compiler-runtime";
import { useIntl } from '@onefootprint/hooks';
import { IcoUser24 } from '@onefootprint/icons';
import type { SignalSeverity } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type { DeviceVisitEvent } from '@/components/entities/components/details/hooks/use-entity-device-insights';
import { displayForUserAgent, icoForUserAgent } from '@/utils/user-agent';
import CardBase from '../card-base';
import CardRow from '../card-row';
import getRegion from '../insight-event-card/utils/get-region';
type DeviceVisitCardProps = {
  id: string;
  isSelected?: boolean;
  onSelect?: (id: string) => void;
  data: DeviceVisitEvent;
};
const severityColor: Record<SignalSeverity, string> = {
  high: 'text-error',
  medium: 'text-warning',
  low: 'text-info',
  info: 'text-neutral'
};
const DeviceVisitCard = t0 => {
  const $ = _c(68);
  const {
    id,
    data,
    isSelected,
    onSelect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "deviceInsights"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "onboardings.riskSignals.severity"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    t: tSeverity
  } = useTranslation("entity-details", t2);
  const {
    formatDateWithTime
  } = useIntl();
  const visit = data.event.data;
  let t3;
  if ($[2] !== visit.ipCity || $[3] !== visit.ipRegion) {
    t3 = getRegion(visit.ipCity, visit.ipRegion);
    $[2] = visit.ipCity;
    $[3] = visit.ipRegion;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const region = t3;
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp2);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp3);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t(_temp4);
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = {
      sdk_start: t4,
      onboard_start: t5,
      handoff: t6,
      identity_document_start: t7
    };
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const pathToText = t8;
  let t9;
  if ($[18] !== t) {
    t9 = t(_temp5);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== formatDateWithTime || $[21] !== visit.timestamp) {
    t10 = formatDateWithTime(new Date(visit.timestamp));
    $[20] = formatDateWithTime;
    $[21] = visit.timestamp;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = <CardRow key="date-time" label={t9} value={t10} />;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t || $[27] !== visit.ipAddress) {
    t12 = visit.ipAddress && <CardRow key="ip-address" label={t(_temp6)} value={visit.ipAddress} />;
    $[26] = t;
    $[27] = visit.ipAddress;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== region || $[30] !== t) {
    t13 = region && <CardRow key="region" label={t(_temp7)} value={region} />;
    $[29] = region;
    $[30] = t;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t || $[33] !== visit.ipCountry) {
    t14 = visit.ipCountry && <CardRow key="ip-country" label={t(_temp8)} value={visit.ipCountry} />;
    $[32] = t;
    $[33] = visit.ipCountry;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t || $[36] !== visit.deviceCountry) {
    t15 = visit.deviceCountry && <CardRow key="device-country" label={t(_temp9)} value={visit.deviceCountry} />;
    $[35] = t;
    $[36] = visit.deviceCountry;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t || $[39] !== visit.deviceTimeZone) {
    t16 = visit.deviceTimeZone && <CardRow key="device-time-zone" label={t(_temp10)} value={visit.deviceTimeZone} />;
    $[38] = t;
    $[39] = visit.deviceTimeZone;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t11 || $[42] !== t12 || $[43] !== t13 || $[44] !== t14 || $[45] !== t15 || $[46] !== t16 || $[47] !== tSeverity || $[48] !== visit.signals) {
    let t18;
    if ($[50] !== tSeverity) {
      t18 = signal => <CardRow key={signal.reasonCode} label={signal.note} value={<span className={`text-body-2 ${severityColor[signal.severity]}`}>{tSeverity($_9 => $_9[signal.severity])}</span>} />;
      $[50] = tSeverity;
      $[51] = t18;
    } else {
      t18 = $[51];
    }
    t17 = [t11, t12, t13, t14, t15, t16, ...visit.signals.map(t18)];
    $[41] = t11;
    $[42] = t12;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
    $[46] = t16;
    $[47] = tSeverity;
    $[48] = visit.signals;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  const rows = t17;
  let t18;
  if ($[52] !== id || $[53] !== onSelect) {
    t18 = () => onSelect?.(id);
    $[52] = id;
    $[53] = onSelect;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  const t19 = pathToText[visit.path];
  let t20;
  if ($[55] !== visit.userAgent) {
    t20 = visit.userAgent ? icoForUserAgent(visit.userAgent, "quinary") : <IcoUser24 color="quinary" />;
    $[55] = visit.userAgent;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] !== t || $[58] !== visit.userAgent) {
    t21 = visit.userAgent ? displayForUserAgent(visit.userAgent) : t(_temp11);
    $[57] = t;
    $[58] = visit.userAgent;
    $[59] = t21;
  } else {
    t21 = $[59];
  }
  let t22;
  if ($[60] !== id || $[61] !== isSelected || $[62] !== rows || $[63] !== t18 || $[64] !== t19 || $[65] !== t20 || $[66] !== t21) {
    t22 = <CardBase id={id} isSelected={isSelected} onSelect={t18} title={t19} headerIcon={t20} headerText={t21} rows={rows} />;
    $[60] = id;
    $[61] = isSelected;
    $[62] = rows;
    $[63] = t18;
    $[64] = t19;
    $[65] = t20;
    $[66] = t21;
    $[67] = t22;
  } else {
    t22 = $[67];
  }
  return t22;
};
export default DeviceVisitCard;
function _temp($) {
  return $.visitPath.sdk_start;
}
function _temp2($_0) {
  return $_0.visitPath.onboard_start;
}
function _temp3($_1) {
  return $_1.visitPath.handoff;
}
function _temp4($_2) {
  return $_2.visitPath.identity_document_start;
}
function _temp5($_3) {
  return $_3.dateAndTime;
}
function _temp6($_4) {
  return $_4.ipAddress;
}
function _temp7($_5) {
  return $_5.region;
}
function _temp8($_6) {
  return $_6.ipCountry;
}
function _temp9($_7) {
  return $_7.deviceCountry;
}
function _temp10($_8) {
  return $_8.deviceTimeZone;
}
function _temp11($_10) {
  return $_10.noDeviceData;
}